import { get } from 'lodash';
import labelsFile from '../../common/labels.json';
import { getLang } from './detectLanguage';
var env = process.env.NODE_ENV;
export function getLabel(key, params, fallback) {
    var lang = getLang();
    if (!labelsFile)
        throw Error('Labels file is missing');
    var labels = labelsFile[lang];
    var requestedLabel = get(labels, key, undefined);
    if (!requestedLabel) {
        if (env !== 'test')
            console.warn('Missing label for: ', key);
        return fallback !== null && fallback !== void 0 ? fallback : 'NO LABEL';
    }
    var label = requestedLabel;
    if (params) {
        Object.keys(params).forEach(function (paramKey) {
            label = label.replace("{{".concat(paramKey, "}}"), params[paramKey]);
        });
    }
    return label;
}
//# sourceMappingURL=labelsService.js.map